import moment from 'moment-timezone';
import React, { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import ConciergeController, { CHAT_SENDER_HOTEL } from '../../controller/ConciergeController';
import DetectorController, {
  ChatDetailType,
  ChatRoomType,
} from '../../controller/DetectorController';
import '../../styles/CustomModal.css';
import ConfirmModal from './ConfirmModal';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  roomName: string;
  chatDetail: ChatDetailType[];
  isMobile: boolean;
  chat: ChatRoomType;
  setChatDetail: any;
  status: number;
  getChatDetails: any;
};

const ChatDetailModal = ({
  isVisible,
  setVisible,
  roomName,
  chatDetail,
  isMobile,
  chat,
  setChatDetail,
  status,
  getChatDetails,
}: Props) => {
  // const [height, setHeight] = useState<number>(0);

  const [reply, setReply] = useState<string>('');
  const [isComposing, setIsComposing] = useState<boolean>(false);

  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);

  const chatEndRef = useRef<HTMLDivElement | null>(null);

  const onCloseModal = () => {
    setVisible(false);
    setVisibleConfirm(false);
  };
  const scrollToBottom = () => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleCompositionStart = () => {
    setIsComposing(true);
  };

  const handleCompositionEnd = () => {
    setIsComposing(false);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (isComposing) return;

    // if (e.key === 'Enter' && !e.shiftKey) {
    //   e.preventDefault();
    //   sendRequest();
    // }
  };

  const sendRequest = async () => {
    console.log('reply', reply, reply.length);
    if (reply === '') {
      toast.error('답변을 입력해주세요.');
    } else {
      const newMessage = {
        sender_type: 'ADMIN',
        read: 1,
        created_at: new Date(),
        read_at: null,
        chat: reply,
      };

      try {
        const oParams = {
          cs_id: chat.cs_id,
          message: reply,
          sender_type: 'ADMIN',
          contact_person: '관리자',
        };

        setReply('');

        const oRes: any = await DetectorController.writeMessage(oParams);

        if (oRes && oRes.data.ok) {
          getChatDetails(chat);
        }
      } catch (err) {
        console.log('err-->', err);
      }
    }
  };

  const finishChat = async () => {
    try {
      const oParams = {
        cs_id: chat.cs_id,
        sender_type: 'ADMIN',
      };
      const oResponse = await DetectorController.finishChat(oParams);
      if (oResponse && oResponse.data) {
        const oRes = oResponse.data;
        if (oRes && oRes.ok) {
          onCloseModal();
          toast.success('상담이 종료되었습니다');
        }
      }
    } catch (e) {
      console.error('err => ', e);
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [chatDetail]);

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: 'chatDetailModalOverlay',
        modal: 'chatDetailModal',
        root: 'customModalRoot',
      }}
      showCloseIcon={!isMobile}
      animationDuration={150}>
      <Style>
        <div className={`modalWrapper`}>
          <div className="modalTitle">
            {isMobile && (
              <img
                onClick={() => setVisible(false)}
                className="closeIcon"
                src={`${process.env.PUBLIC_URL}/svg/ic_back_bold.svg`}
                alt="back"
              />
            )}
            <div className="headerBar" />
            <h2>{roomName}</h2>
          </div>

          <div className="modalContent">
            <div className="chatWrap">
              {chatDetail.map((item, index) => (
                <div key={index} className={`chat ${item.sender_type === 'ADMIN' && 'mine'}`}>
                  {item.sender_type === 'ADMIN' && item.read === 0 && <p className="read">1</p>}
                  {item.sender_type === 'ADMIN' && !item.failed && (
                    <p>
                      {`${new Date(item.created_at).getHours() > 12 ? '오후' : '오전'} ${moment(
                        new Date(item.created_at),
                      ).format('HH:mm')}`}
                    </p>
                  )}
                  {item.sender_type === 'ADMIN' && item.failed && (
                    <div className="flex">
                      <img
                        src={`${process.env.PUBLIC_URL}/svg/ic_important.svg`}
                        alt="답변보내기"
                      />
                      <p className="failedMsg">전송실패</p>
                    </div>
                  )}
                  <h4 className={`${item.chat.length === 0 && 'empty'}`}>{item.chat}</h4>
                  {item.sender_type !== 'ADMIN' && (
                    <p>{`${new Date(item.created_at).getHours() > 12 ? '오후' : '오전'} ${moment(
                      new Date(item.created_at),
                    ).format('HH:mm')}`}</p>
                  )}
                </div>
              ))}
              <div ref={chatEndRef} />
              {status === 1 && (
                <div className="chat finished">
                  <h4>상담이 종료되었습니다</h4>
                </div>
              )}
            </div>
            {status !== 1 && (
              <>
                <div className="receivedWrap">
                  <textarea
                    id={isMobile ? 'resizeArea' : ''}
                    value={reply}
                    onChange={(e) => setReply(e.target.value)}
                    placeholder="답변을 입력해주세요"
                    onKeyDown={handleKeyPress}
                    disabled={status === 1}
                    onCompositionStart={handleCompositionStart}
                    onCompositionEnd={handleCompositionEnd}
                  />
                  <button onClick={sendRequest} className="confirmButton">
                    {isMobile ? (
                      <img src={`${process.env.PUBLIC_URL}/svg/ic_receive.svg`} alt="답변보내기" />
                    ) : (
                      <h3>답변 보내기</h3>
                    )}
                  </button>
                </div>
                <button onClick={() => setVisibleConfirm(true)} className="endButton">
                  <h3>상담 종료하기</h3>
                </button>
              </>
            )}
          </div>
        </div>
      </Style>
      <ConfirmModal
        isOpen={visibleConfirm}
        title={'상담을 종료하시겠습니까\n종료 후 대화내역은 모두 삭제됩니다'}
        onConfirmText="종료"
        onCancelText="취소"
        onConfirm={finishChat}
        onCancel={() => setVisibleConfirm(false)}
      />
    </Modal>
  );
};

export default ChatDetailModal;

const Style = styled.div`
  .flex {
    display: flex;
    align-items: center;
  }
  li::marker {
    color: #4dd2ae;
  }

  .modalWrapper {
    display: flex;
    height: 70dvh;
    flex-direction: column;
    gap: 16px;
    overflow: hidden;
    text-align: left;
  }
  .modalWrapper.notKr {
    gap: 40px;
  }
  .modalTitle {
    .headerBar {
      width: 44px;
      height: 5px;
      margin: 0 auto;
      border-radius: 10px;
      background: #4dd2ae;
    }
    h2 {
      margin-top: 22px;
      font-size: 24px;
      font-weight: 500;
      color: #555;
      text-align: center;
    }
    .translateWrap {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 8%;
      gap: 8px;
      .translate {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 4px 18px;
        border-radius: 5px;
        border: 1px solid #cecece;
        h4 {
          font-size: 16px;
          font-weight: 500;
          color: #979797;
        }
      }
      .translate.active {
        border: 1px solid #4dd2ae;
        h4 {
          font-weight: 600;
          color: #4dd2ae;
        }
      }
    }
  }

  .modalContent {
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;
    padding: 0 8%;
    overflow: auto;
    .chatWrap {
      height: 100%;
      display: flex;
      flex-direction: column;
      gap: 10px;
      background: #ecf5f3;
      /* border: 1px solid #cecece; */
      border: none;
      border-radius: 10px;
      padding: 20px;
      overflow: auto;

      .chat {
        display: flex;
        position: relative;
        align-items: flex-end;
        justify-content: flex-start;
        white-space: pre-line;
        width: 100%;

        h4 {
          font-size: 18px;
          line-height: 26px;
          color: #555555;
          font-weight: 400;
          padding: 6px 20px;
          background: #ffffff;
          border-radius: 20px;
          white-space: pre-line;
          word-break: break-all;
          max-width: 80%;
        }
        p {
          font-size: 12px;
          line-height: 18px;
          font-weight: 500;
          color: #737373;
          margin: 0 0 0 6px;
        }
        p.read {
          font-size: 12px;
          line-height: 18px;
          font-weight: 600;
          color: #ff6060;
          margin: 0 0 0 8px;
        }
        h4.empty {
          width: 60px;
          height: 38px;
        }
      }
      .chat.mine {
        justify-content: flex-end;

        h4 {
          color: #ffffff;
          background: #40977f;
        }
        p {
          text-align: right;
          margin: 0 6px 0 0;
        }
        p.read {
          margin: 0 8px 0 0;
        }
      }
      .failedMsg {
        white-space: nowrap;
        font-weight: 500;
        color: #ff6060;
      }
    }

    .chat.finished {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      h4 {
        padding: 4px 20px;
        border-radius: 50px;
        border: 1px solid #e5e5e5;
        font-size: 12px;
        line-height: 18px;
        font-weight: 400;
        color: #979797;
        background: transparent;
      }
    }

    .receivedWrap {
      display: flex;
      flex-direction: column;
      gap: 16px;
      textarea {
        width: 100%;
        height: 120px;
        padding: 12px 24px;
        background: #ffffff;
        border: 1px solid #cecece;
        border-radius: 10px;
        font-size: 18px;
        line-height: 24px;
        color: #555555;
        font-weight: 400;
      }
      textarea::placeholder {
        color: #979797;
      }
    }
  }

  .confirmButton {
    margin: 30px 0 0 0;
    padding: 12px 0;
    background: #4dd2ae;
    border: none;
    h3 {
      font-weight: 700;
    }
  }

  .endButton {
    padding: 11px 0;
    background: #fff;

    border: 1px solid #4dd2ae;
    border-radius: 10px;
    h3 {
      line-height: 24px;
      font-weight: 700;
      color: #4dd2ae;
    }
  }

  @media (max-width: 900px) {
    .modalWrapper {
      height: 100vh;
      display: flex;
      gap: 10px;
      padding-bottom: 0;
    }

    .closeIcon {
      position: absolute;
      top: 30px;
      left: 20px;
    }

    .headerBar {
      display: none;
    }

    .modalTitle {
      position: relative;
      padding: 30px 0;
      h2 {
        margin: 0;
      }
    }

    .modalContent {
      padding: 0 4%;
      gap: 0;

      .chatWrap {
        gap: 10px;
        /* border: 1px solid #cecece; */
        border: none;
        background: #eeeeee;
        padding: 30px 10px;
        margin-bottom: 20px;
        height: calc(100dvh - 280px);
        .chat {
          h4 {
            font-size: 14px;
            line-height: 22px;
            padding: 4px 18px;
          }
          p {
            font-size: 10px;
            margin: 0 0 0 4px;
          }
        }
        .chat.mine {
          p {
            margin: 0 4px 0 0;
          }
        }
      }

      .receivedWrap {
        flex-direction: row;
        gap: 8px;
        padding: 10px 0;

        textarea {
          height: 48px;
        }
      }
    }

    .confirmButton {
      margin: 0;
      padding: 0 18px;
      background: #4dd2ae;
      border: none;
      h3 {
        font-weight: 700;
      }
      img {
        margin-top: 6px;
      }
    }
    .endButton {
      margin-top: 20px;
    }
  }
`;
